var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initialized)?_c('div',{staticClass:"one-off-offering-flow"},[(_vm.index === 0 && _vm.configs)?_c('one-off-landing-page',{on:{"next":_vm.next,"close":_vm.close,"back":_vm.close}}):_vm._e(),_vm._v(" "),(_vm.index === 1)?_c('payment-page',{on:{"back":_vm.back,"close":_vm.close}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }